export default __webpack_public_path__ + "static/media/hm_hyattfeat.94793949.jpg";